(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/sub-header/assets/javascripts/sub-header.js') >= 0) return;  svs.modules.push('/components/casino-react/sub-header/assets/javascripts/sub-header.js');
"use strict";


const {
  ReactIconButton: IconButton,
  ReactIcon: Icon
} = svs.ui;
const handleBackClick = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const returnUrl = urlParams.get('returnUrl');
  if (returnUrl) {
    const decodedUrl = decodeURIComponent(returnUrl);
    const internalRoute = svs.utils.url.makeInternal(decodedUrl);
    if (internalRoute) {
      window.location.href = internalRoute;
    } else {
      svs.utils.url.navigate(svs.core.urlMapping.get('casinoSearch'));
    }
  } else {
    svs.utils.url.navigate(svs.core.urlMapping.get('casinoSearch'));
  }
};
const SubHeader = _ref => {
  let {
    title
  } = _ref;
  return React.createElement("div", {
    className: "casino-sub-header"
  }, React.createElement(IconButton, {
    "aria-label": "G\xE5 tillbaks",
    className: "casino-sub-header__icon",
    onClick: handleBackClick
  }, React.createElement(Icon, {
    color: "fc-white",
    icon: "menu-left",
    size: "300"
  })), React.createElement("div", {
    className: "casino-sub-header__heading-wrapper"
  }, React.createElement("h2", {
    className: "f-content casino-sub-header__heading"
  }, title)));
};
setGlobal('svs.components.casino_react.sub_header.SubHeader', SubHeader);

 })(window);